module.exports = __webpack_public_path__ + "img/abbeyroad-cover.ef39d7c0.jpg";